export default __webpack_public_path__ + "static/media/img_step_appliance09.4f19be26.jpg";